export const numberWithCommas = (num: number = 0): string => {
  const [whole, decimal] = num.toString().split('.');
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decimal || '00'}`;
};

export const formatToCurrency = (amount: number): string =>
  `₦${numberWithCommas(amount)}`;

const createEnvChecker = (env: 'development' | 'production') => <T>(
  callback: () => T | undefined,
  elseCallback?: () => T | undefined
): T | undefined => {
  if (process.env.NODE_ENV === env) {
    return callback();
  }
  return elseCallback?.();
};

export const inProduction = createEnvChecker('production');
export const inDevelopment = createEnvChecker('development');
